"use client";
import React, { useState, useEffect } from "react";
// Usamos los mismos estilos de Programas Académicos para replicar el diseño
import styles from "../../styles/PantallaDeProgramasAcademicos.v2.module.css";
import estudiantesStyles from "../../styles/EstudiantesStyles/Estudiantes.module.css";
import HeaderGlobal from "../../components/HeaderGlobal";
import Sidebar from "../../components/Sidebar";
import SeccionesTable from "./SeccionesTable";
import NuevaSeccionModal from "./NuevaSeccionModal";
import { createSeccion, updateSeccion, deleteSeccion, getSecciones } from '../../api/secciones';
import { usePermissions } from '../../hooks/usePermissions';
import LoaderOverlay from "../../components/LoaderOverlay";

function PantallaDeSecciones() {
  const { canCreate, canEdit, canView } = usePermissions();
  const puedeCrear =
    canCreate('Catálogos') ||
    canEdit('Catálogos') ||
    canView('Catálogos');

  const [openNew, setOpenNew] = useState(false);
  const [editData, setEditData] = useState(null);
  const [secciones, setSecciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);
  const [query, setQuery] = useState("");

  useEffect(() => {
  setLoading(true);
  getSecciones().then((res) => {
    console.log("SECCIONES RECIBIDAS:", res);
    setSecciones(res);
  }).finally(() => setLoading(false));
}, [refreshKey]);


useEffect(() => {
  setLoading(true);
  getSecciones().then((res) => {
    console.log("SECCIONES LIMPIAS:", res);
    res.forEach((item, index) => {
      console.log(`ROW ${index}:`, item);
      Object.entries(item).forEach(([key, value]) => {
        if (typeof value === 'object' && value !== null) {
          console.warn(`ROW ${index} FIELD ${key}:`, value, '⚠️ ES UN OBJETO');
        } else {
          console.log(`ROW ${index} FIELD ${key}:`, value);
        }
      });
    });
    setSecciones(res);
  }).finally(() => setLoading(false));
}, []);


  const handleCreate = async (data) => {
    await createSeccion(data);
    setRefreshKey(k => k + 1);
  };

  const handleEdit = async (id, data) => {
    await updateSeccion(id, data);
    setRefreshKey(k => k + 1);
  };

  const handleDelete = async (id) => {
    await deleteSeccion(id);
    setRefreshKey(k => k + 1);
  };

  const handleSearch = () => {
    // En el futuro se puede filtrar SeccionesTable usando `query`
    console.log('Buscando secciones con término:', query);
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.layout}>
        <div className={styles.sidebarColumn}>
          <Sidebar />
        </div>
        <div className={styles.contentColumn}>
          <main className={styles.mainContent}>
            <HeaderGlobal title="Secciones Académicas" />
            <div className={styles.contentArea}>
              <div className={styles.contentWrapper}>
                <LoaderOverlay visible={loading} label="Cargando secciones..." />
                <div className={estudiantesStyles.searchSection}>
                  <div className={estudiantesStyles.searchCard}>
                    <div className={styles.programsSearchRow}>
                      <div className={estudiantesStyles.searchInputGroup}>
                        <svg
                          className={estudiantesStyles.searchIcon}
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
                            stroke="#898d8d"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <input
                          type="text"
                          className={estudiantesStyles.searchInput}
                          placeholder="Buscar Sección..."
                          aria-label="Buscar sección"
                          value={query}
                          onChange={(e) => setQuery(e.target.value)}
                          onKeyPress={(e) => {
                            if (e.key === 'Enter') handleSearch();
                          }}
                        />
                      </div>

                      <button
                        className={styles.buscarButtonProgramas}
                        onClick={handleSearch}
                      >
                        Buscar
                      </button>

                      {puedeCrear && (
                        <button
                          className={styles.newProgramButton}
                          aria-label="Crear nueva sección"
                          onClick={() => { setEditData(null); setOpenNew(true); }}
                        >
                          + Nueva Sección
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                {/* Tabla de secciones académicas */}
                <SeccionesTable
                  data={secciones}
                  loading={loading}
                  onEdit={row => { setEditData(row); setOpenNew(true); }}
                  onDelete={handleDelete}
                />
              </div>
            </div>
          </main>
        </div>
      </div>
      <NuevaSeccionModal
        open={openNew}
        onClose={() => { setOpenNew(false); setEditData(null); }}
        onSubmit={editData ? (data) => handleEdit(editData.id, data) : handleCreate}
        initialData={editData}
      />
    </div>
  );
}

export default PantallaDeSecciones;
